// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__jVFVz","toggle":"style_toggle__2T+ZR","mapTypes":"style_mapTypes__WyLlj","mapType":"style_mapType__aSQoV"};